module.exports = __webpack_public_path__ + "img/nordic-walking.78422e64.svg";